"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Preloader = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
const Preloader = props => {
  const {
    lines
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "fields read-only",
    ...props,
    children: lines.map((line, index) => {
      if (line === 'label-field') {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "label",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "preloader preloader--line preloader--line--label preloader--shine"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "preloader preloader--line preloader--shine"
            })
          })]
        }, `${line}-${index}`);
      }
      if (line === 'title') {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "preloader preloader--line preloader--line--title preloader--shine"
        }, `${line}-${index}`);
      }
      if (line === 'label') {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "label",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "preloader preloader--line preloader--line--label preloader--shine"
          })
        }, `${line}-${index}`);
      }
      if (line === 'line') {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "preloader preloader--line preloader--shine"
          })
        }, `${line}-${index}`);
      }
      return null;
    })
  });
};
exports.Preloader = Preloader;